import { TFunction } from 'react-i18next';
import { Step } from 'pages/AutomationEngine/types';
import { CardProps } from '../../types';
import DraggableStepCard from '__pages/AutomationEngine/Engine/Steps/DraggableStepCard';
import { AutomationStepAction } from 'ts-components/Plugins/automations';
import { AutomationStep } from 'ts-components/Plugins/types';

type GetDescription = {
  step: Step & {
    details: SnakeToCamelCase<AutomationStepAction>;
  };
  automationSteps: AutomationStep<AutomationStepAction>[];
  t: TFunction;
};

export const content = ({ step }: { step: Step }) => step.description;

export const getDescription = ({
  step,
  automationSteps,
  t,
}: GetDescription) => {
  const {
    details: { actionStepApiName, pluginAppApiName },
  } = step;

  const automationStep = automationSteps.find(
    (s) => s.plugin_api_name === pluginAppApiName
  );

  if (!automationStep) {
    return t('Plugin (Unknown)');
  }

  const pluginName = automationStep.name;
  const pluginAction = automationStep.actions[actionStepApiName] || undefined;

  return (
    pluginAction?.actionDescription ??
    t(`{{pluginName}} - {{pluginAction}}`, {
      pluginName,
      pluginAction: pluginAction ? pluginAction.name : t('Unknown'),
    })
  );
};

export default function PluginCodeStepCard({
  type,
  step,
  ...others
}: CardProps) {
  return <DraggableStepCard {...others}>{content({ step })}</DraggableStepCard>;
}
